export const GET_ALL_FAQ = "faq/GET_ALL_FAQ";
export const GET_ALL_FAQ_SUCCESS = "faq/GET_ALL_FAQ_SUCCESS";
export const GET_ALL_FAQ_FAIL = "faq/GET_ALL_FAQ_FAIL";

export const UPDATE_SHOWED_FAQ_BY_GROUP = "faq/UPDATE_SHOWED_FAQ_BY_GROUP";

export const UPDATE_SHOWED_FAQ_BY_SEARCH = "faq/UPDATE_SHOWED_FAQ_BY_SEARCH";
export const UPDATE_SHOWED_FAQ_BY_SEARCH_SUCCESS =
  "faq/UPDATE_SHOWED_FAQ_BY_SEARCH_SUCCESS";

export const UPDATE_SHOWED_FAQ_BY_SEARCH_FAIL =
  "faq/UPDATE_SHOWED_FAQ_BY_SEARCH_FAIL";
